import { useTranslation } from 'react-i18next';
import { PageBreadcrumbs, PageNavigation } from '@client/toolkit';
import { PageContentAnimation } from '../../../components/layout/page-content-animation';

export const MeHeader = () => {
  const { t: tGlobal } = useTranslation('global');

  return (
    <PageContentAnimation className="flex flex-col gap-5">
      <PageNavigation>
        <PageBreadcrumbs>
          <PageBreadcrumbs.Link>{tGlobal('navigation.profile.yourInfo')}</PageBreadcrumbs.Link>
        </PageBreadcrumbs>
      </PageNavigation>
    </PageContentAnimation>
  );
};
